import {
  putRequest,
  getRequest,
  postRequest,
  deleteRequest,
  formDataPutRequest,
} from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";
import { API_URLS } from "../../../constants";

const { PROFILE } = API_URLS;

// Posting User Permission
const addUserPermission = (body) => {
  return postRequest(PROFILE.BASE, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Getting Paginated Users
const getUsers = (body) => {
  return postRequest(PROFILE.GET, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Updating Users
const updateUsers = (body) => {
  return putRequest(PROFILE.BASE, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Deleting Users
const deleteUserDetails = (userId) => {
  return deleteRequest(`${PROFILE.BASE}/${userId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Reset password in user permission page
const resetPassword = (body) => {
  return putRequest(PROFILE.CHANGE_PASSWORD, body).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Getting the permission against brandId
const getUserPermissionByBrandId = (brandId) => {
  return getRequest(
    `${API_URLS.USER_PERMISSION.GET_USER_PERMISSION}/${brandId}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Getting the permission against groupId
const getUserPermissionByGroupId = (groupId) => {
  return getRequest(
    `${API_URLS.USER_PERMISSION.GET_USER_PERMISSION_FOR_GROUP}/${groupId}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Getting the permission against managerId
const getUserPermissionByManagerId = (managerId) => {
  return getRequest(
    `${API_URLS.USER_PERMISSION.GET_USER_PERMISSION_FOR_MANAGER}/${managerId}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Deleting Users
const deleteUserProfileImage = (userId) => {
  return deleteRequest(`${PROFILE.DELETE_PROFILE_IMAGE}/${userId}`).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Resend create password email to User having current userId
const resendCreatePasswordEmail = (userId) => {
  return postRequest(
    `${PROFILE.RESEND_CREATE_PASSWORD_EMAIL}/${userId}`,
    {}
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Updating User profile pic
const updateUserProfilePic = (data) => {
  return formDataPutRequest(PROFILE.UPDATE_PROFILE_PIC, data).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Getting user by id
const getUserById = (userId) =>
  getRequest(`${PROFILE.GET_USER_BY_ID}/${userId}`)
    .then((response) => responseHandler.handleServerResponse(response))
    .catch((error) => responseHandler.handleHTTPResponses(error.response));

//Exporting functions for other files
export const userPermissionsService = {
  getUsers,
  updateUsers,
  getUserById,
  resetPassword,
  addUserPermission,
  deleteUserDetails,
  updateUserProfilePic,
  deleteUserProfileImage,
  resendCreatePasswordEmail,
  getUserPermissionByBrandId,
  getUserPermissionByGroupId,
  getUserPermissionByManagerId,
};
